import i18n from "../../../../constants/i18n";
import getKhattabatFilterStore from "../../../../stores/khattabat-stores/filter-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";

const ApplyButton = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const isActiveFilter = getKhattabatFilterStore().isActiveFilter.get();

  return (
    <ET3Div
      width={100}
      height={100}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Div
        width={100}
        height={60}
        alignItems={"center"}
        fDirection={"row"}
        style={{
          border: 10 * unitX,
          borderRadius: 15 * unitX,
          cursor: "pointer"
        }}
        color={isActiveFilter ? colors.all.blue : colors.all.dimGray}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() =>
          isActiveFilter ? getKhattabatFilterStore().handleFiltering() : null
        }
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={20}
          isSpan={true}
          text={i18n.get("APPLY")}
          style={{
            color: isActiveFilter ? colors.all.black : colors.all.white
          }}
          color={""}
        />
      </ET3Div>
    </ET3Div>
  );
});

export default ApplyButton;
